import { PageListCachedDataSource } from './BaseDataSources';
import { ISeller } from '../Interfaces';

export class TrusteeSource extends PageListCachedDataSource<ISeller> {
  public constructor(isActive?: boolean) {
    super('/datasource/trustees', { isActive });
  }
}